import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=3925f724&"
import script from "./ArrowLink.vue?vue&type=script&lang=ts&"
export * from "./ArrowLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports